<template>
	<div id="page-content" class="component-padding page-content-bg-a">
		<div id="accountselect">
			<h1>Choose your Apollo Account. Sign up is free!</h1>
			<div id="accountselectrow">

				<div class="col-md-6">
					<div class="account-type">
						<h1>Buy Apollo Products</h1>
						<p>For people who want to buy apollo lighting fixtures</p>

						<router-link to="/registration/buyer" class="button-type-g">Get Started</router-link>

						<ul>
							<li>Buy all kinds of lighting fixtures from Apollo</li>
							<li>Other information that can be used to promote this feature</li>
						</ul>
					</div>
				</div>

				<div class="col-md-6">
					<div class="account-type">
						<h1>Be a supplier of Apollo</h1>
						<p>For people who want be a supplier of Apollo</p>
						<!--router-link to="/registration/supplier" -->
						<button class="button-type-g button-type-g-disabled" disabled>Coming Soon</button>

						<ul>
							<li>Buy all kinds of lighting fixtures from Apollo</li>
							<li>Other information that can be used to promote this feature</li>
							<li>Propose products to Apollo</li>
							<li>Get paid by Apollo to be something information to be part here</li>
						</ul>
					</div>
				</div>

			</div>
		</div>
	</div>
</template>

<script>
	export default{
		props: ['issessionset'],
		data(){
			return{

			}
		},
		created(){
			if(this.issessionset === true){
				this.$router.push({path: '/user'});
			}
		},
		mounted(){
			relativeTo('nav', this.$el);
		},
		watch: {
			issessionset: function(newval){
				if(newval === true){
					this.$router.push({path: '/user'});
				}		
			}
		}
	}
</script>


// WEBPACK FOOTER //
// AccountSelection.vue?6fd3b950